import React, {MutableRefObject} from 'react'
import {createPortal} from 'react-dom'

import {EmojiOption} from "./option"
import EmojiMenuComponent from "./menu-component"

const debug = false
// const debug = "emojiMenu"

export default function emojiMenu (
    anchorElementRef: MutableRefObject<HTMLElement | null>, itemProps: {
        selectedIndex           : number | null
        selectOptionAndCleanUp  : (option: EmojiOption) => void
        setHighlightedIndex     : (index: number) => void
        options                 : Array<EmojiOption>
    }, matchingString: string | null
) {
    if (!anchorElementRef.current || !itemProps.options.length) return null

    return createPortal(
        <EmojiMenuComponent anchorElementRef    = {anchorElementRef}
                            itemProps           = {itemProps}
                            matchingString      = {matchingString}/>,
        anchorElementRef.current,
    )
}
